export function taskPlanningIndexRequest(id, projectId) {
  return {
    type: '@taskPlannings/INDEX_REQUEST',
    payload: { id, projectId },
  };
}

export function taskPlanningIndexSuccess(data) {
  return {
    type: '@taskPlannings/INDEX_SUCCESS',
    payload: { data },
  };
}

export function taskPlanningIndexFailure() {
  return {
    type: '@taskPlannings/INDEX_FAILURE',
  };
}

export function taskPlanningCreateRequest(data) {
  return {
    type: '@taskPlannings/CREATE_REQUEST',
    payload: { data },
  };
}

export function taskPlanningCreateSuccess(data) {
  return {
    type: '@taskPlannings/CREATE_SUCCESS',
    payload: { data },
  };
}

export function taskPlanningCreateFailure() {
  return {
    type: '@taskPlannings/CREATE_FAILURE',
  };
}

export function taskPlanningReadRequest(id, taskId, projectId) {
  return {
    type: '@taskPlannings/READ_REQUEST',
    payload: { id, projectId, taskId },
  };
}

export function taskPlanningReadSuccess(data) {
  return {
    type: '@taskPlannings/READ_SUCCESS',
    payload: { data },
  };
}

export function taskPlanningReadFailure() {
  return {
    type: '@taskPlannings/READ_FAILURE',
  };
}

export function taskPlanningUpdateRequest(data) {
  return {
    type: '@taskPlannings/UPDATE_REQUEST',
    payload: { data },
  };
}

export function taskPlanningUpdateSuccess(data) {
  return {
    type: '@taskPlannings/UPDATE_SUCCESS',
    payload: { data },
  };
}

export function taskPlanningUpdateFailure() {
  return {
    type: '@taskPlannings/UPDATE_FAILURE',
  };
}

export function taskPlanningDeleteRequest(id, taskId, projectId) {
  return {
    type: '@taskPlannings/DELETE_REQUEST',
    payload: { id, taskId, projectId },
  };
}

export function taskPlanningDeleteSuccess() {
  return {
    type: '@taskPlannings/DELETE_SUCCESS',
  };
}

export function taskPlanningDeleteFailure() {
  return {
    type: '@taskPlannings/DELETE_FAILURE',
  };
}
